import React from "react";
import { Button } from "reactstrap";
import MonitoringEnableModal from "./MonitoringEnableModal";

/**
 * Not-enabled monitoring landing (Option B): header + count + Enable CTA.
 * Enable form lives in a modal; tabs only appear after project exists (B1).
 */
export default function MonitoringLanding({
	websiteLabel = "",
	websiteId = null,
	enableOpen = false,
	onOpenEnable,
	onCloseEnable,
	onEnable,
	busy = false,
	error = null,
}) {
	return (
		<div className="monitoring monitoring--landing">
			<div className="monitoring__landing-header">
				<div className="monitoring__landing-header-text">
					<h2 className="monitoring__landing-title mb-0">Monitoring projects</h2>
					<span className="monitoring__landing-count">
						0 websites · 0 active
					</span>
				</div>
				<Button
					color="primary"
					className="monitoring__enable-btn"
					onClick={onOpenEnable}
					disabled={!websiteId}
				>
					Enable monitoring
				</Button>
			</div>
			<p className="monitoring__landing-lead text-muted mb-0">
				One project per website. Enable monitoring for{" "}
				{websiteLabel ? (
					<code className="monitoring__inline-code">{websiteLabel}</code>
				) : (
					"the current Store"
				)}{" "}
				to open the dashboard and tabs.
			</p>

			<div className="monitoring__landing-empty">
				<p className="mb-0">
					No monitoring project for this website yet. Click{" "}
					<strong>Enable monitoring</strong> to start.
				</p>
			</div>

			<MonitoringEnableModal
				isOpen={enableOpen}
				onClose={onCloseEnable}
				onEnable={onEnable}
				busy={busy}
				error={error}
				websiteLabel={websiteLabel}
				websiteId={websiteId}
			/>
		</div>
	);
}
